import { PROD } from '../../../config/stage'
import apiBaseUrl from '../baseUrl'

const stagePrefix = import.meta.env.VITE_STAGE === PROD ? '' : `${import.meta.env.VITE_STAGE}-`
const formsBaseUrl = `${apiBaseUrl}${stagePrefix}forms`

export default formsBaseUrl
